"use client"

import z from "zod";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table"
import { CronjobSchema } from "@/schemas/cronjob.schema";
import CronjobDeleteModal from "./CronjobDeleteModal";
import CronjobCreateModal from "./CronjobCreateModal";

interface Props {
    cronjobEntries: z.infer<typeof CronjobSchema>[],
    updateData: () => void,
}

export default function CronjobTable(props: Props){
    return (
        <div>
            <div className="flex items-center justify-between mt-2">
                <div className="w-[200px]">
                </div>
                <CronjobCreateModal domainid={null} cronjoboptions={[]} updatedata={props.updateData} />
            </div>

            {props.cronjobEntries.length <= 0 && (
                <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                    <p>No Cronjob Entries available</p>
                </div>
            )}

            {props.cronjobEntries.length > 0 && (
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>DomainID</TableHead>
                            <TableHead>Domain Name</TableHead>
                            <TableHead>CRM Sync</TableHead>
                            <TableHead>Rekvisition</TableHead>
                            <TableHead>UploadsCleanup</TableHead>
                            <TableHead>MailMergeService</TableHead>
                            <TableHead>Delete</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {props.cronjobEntries?.map((entry, _index) => (
                            <TableRow key={entry.ID}>
                                <TableCell>{entry.DomainID}</TableCell>
                                <TableCell>{entry.Name}</TableCell>
                                <TableCell>{entry.CRM_Sync ? "Configured" : "Not Configured"}</TableCell>
                                <TableCell>{entry.Rekvisition ? "Configured" : "Not Configured"}</TableCell>
                                <TableCell>{entry.UploadsCleanup ? "Configured" : "Not Configured"}</TableCell>
                                <TableCell>{entry.MailMergeService ? "Configured" : "Not Configured"}</TableCell>
                                <TableCell><CronjobDeleteModal entry={entry} updatedata={props.updateData} /></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
        </div>
    )
}